<div class="py-4">
  <mat-card class="px-3">
    <mat-card-header class="flex align-items-center">
      <shared-title>Nueva Reserva</shared-title>
      <button
        mat-icon-button
        matTooltip="Limpiar formulario"
        matTooltipPosition="right"
        class="ml-5"
        (click)="clearForm()">
        <mat-icon>cleaning_services</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="formCreated" (ngSubmit)="onSubmit()">
        <div class="grid">
          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
            appearance="outline">
            <mat-label>Edficio</mat-label>
            <mat-select formControlName="buildingId">
              @for (edificio of edificios; track edificio) {
                <mat-option
                  [value]="edificio.buildingid"
                  (click)="chargueFloorByBuilding(edificio.buildingid)">
                  {{ edificio.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
            appearance="outline">
            <mat-label>Nivel</mat-label>
            <mat-select formControlName="selectfloor" #floor>
              @for (floor of floors; track floor) {
                <mat-option
                  [value]="floor.floorid"
                  (click)="selectFloor(floor.floorid)">
                  {{ floor.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
            appearance="outline">
            <mat-label>Usuarios</mat-label>
            <mat-select formControlName="selectWorker">
              @for (worker of workers; track worker) {
                <mat-option
                  [value]="worker.worker_id"
                  (click)="chargueWorkPLaceType()">
                  {{ worker.first_name }} {{ worker.last_name }} -
                  {{ worker.email }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
            appearance="outline">
            <mat-label>Tipo de puesto</mat-label>
            <mat-select formControlName="selectworkplacetype">
              @for (puesto of puestos; track puesto) {
                <mat-option
                  [value]="puesto.workplacetypeid"
                  (click)="selectType(puesto.workplacetypeid)">
                  {{ puesto.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
            appearance="outline">
            <mat-label>Selecciona la fecha</mat-label>
            <input
              matInput
              formControlName="startDate"
              [matDatepicker]="picker"
              readonly
              [(ngModel)]="selectedDate"
              (ngModelChange)="formatDate()"
              [min]="minDate" />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
            appearance="outline">
            <mat-label>Hora</mat-label>
            <mat-select
              formControlName="hours"
              [(ngModel)]="selectedHour"
              (ngModelChange)="updateAvailableMinutes()">
              @for (hour of availableHours(); track hour) {
                <mat-option [value]="hour">
                  {{ hour }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
            appearance="outline">
            <mat-label>Minutos</mat-label>
            <mat-select formControlName="minute" [(ngModel)]="selectedMinute">
              @for (minute of availableMinutes; track minute) {
                <mat-option [value]="minute">
                  {{ minute < 10 ? '0' + minute : minute }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field
            class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
            appearance="outline">
            <mat-label>Duración</mat-label>
            <mat-select formControlName="selectDuration" [(ngModel)]="duration">
              @for (duration of reservationDuration; track duration) {
                <mat-option [value]="duration">
                  {{ duration }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (workplaces) {
            <mat-form-field
              class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-3"
              appearance="outline">
              <mat-label>Puestos Disponibles</mat-label>
              <mat-select formControlName="selectPuesto">
                @for (floor of available().available; track floor) {
                  <mat-option [value]="floor.workplace_id">
                    {{ floor.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>

        <div
          class="flex justify-content-evenly flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
          <mat-checkbox
            [formControl]="hideRequiredControl"
            [(ngModel)]="isActiveSearch">
            Reserva Aleatoria
          </mat-checkbox>
          @if (!isActiveSearch) {
            <shared-button
              class="ml-0 mb-2 sm:ml-0 md:ml-0 lg:ml-5 xl:ml-5 sm:mb-2 md:mb-0 lg:mb-0 xl:mb-0"
              [icon]="'search'"
              [color]="'accent'"
              [typeBtn]="'button'"
              [disabled]="!formCreated.valid"
              (click)="searchWorkPlace()">
              Puestos Disponibles
            </shared-button>
          }
          <shared-button
            [icon]="'save'"
            [color]="'primary'"
            [typeBtn]="'submit'"
            [disabled]="!formCreated.valid">
            Crear reserva
          </shared-button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>

@if (workplaces) {
  <div class="w-full justify-content-center">
    <mat-card class="px-5 py-4 flex justify-content-center">
      <shared-title class="flex justify-content-center">Mapa</shared-title>
      <div class="flex justify-content-center">
        @if (isLoading) {
          <div
            class="p-d-flex p-jc-center p-ai-center"
            style="margin-top: 250px">
            <h1
              class="text-lg md:text-xl lg:text-3xl xl:text-4xl"
              style="margin-left: 350px">
              Cargando...
            </h1>
          </div>
        }
        <div style="overflow: auto">
          <div class="flex justify-content-center">
            <pinch-zoom
              class="flex justify-content-center"
              style="background-color: rgba(255, 255, 255, 0.954)">
              <canvas
                (dblclick)="canvasDblClickk($event)"
                class="flex justify-content-center"
                #canvas>
              </canvas>
            </pinch-zoom>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
}
